// libraries
import React, { useState, useContext } from "react";
import { useParams } from "react-router-dom";
// import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Modal } from "reactstrap";
// //component
import AppButton from "components/app-button";
import pathnames from "routes/pathnames";
import { useEffect } from "react";
// import { updateUserList } from "redux/slices/user-list-slice";
// import appToast from "components/app-toast";
// import IconDownload from "../../assets/images/pages/icon-download-border-none.png";
import { FiSearch } from "react-icons/fi";
import AppReactTable from "components/app-react-table";
// import { IoClose } from "react-icons/io5";
// import AppSearchBar from "components/app-search-bar";

// commons
import CONSTANSTS from "common/constansts";
//import AppButton from "components/app-button"; 
import { IoClose,IoSaveOutline, IoCheckmark } from "react-icons/io5";
import AppCustomToast, { PageContext } from "components/app-custom-toast";


const PageCustomerView = () => {
  
  const indicatorValue = useContext(PageContext);
  function messageDialog(indicator) {
    AppCustomToast({
      showIndicator: indicator,
      reintIndicator: indicatorValue[1](indicator),
    });
  }

  const [tableSearchFilter, setTableSearchFilter] = useState({
    // insert the key value requested by BE here

    pageNumber: 1,
    pageSize: 50,
    sortDirection: "DESCENDING",
    sortKey: "contractDate",
  });

  const initUserDetails = {
    result: {
      name: "null",
      nric: "null",
      referenceNumber:"null",
      username: "null",
      mobileNumber: "null",
      tempMobileNumber:"null",
      email: "null",
      bankName: "null",
      accName: "null",
      accNumber: "null",
      id: "null",
      document:"null",
      auditTrails: "null",
    },
  };
  const [userDetails, setUserDetails] = useState(initUserDetails);
  const temUserDetails = {
    result: {
      Status: userDetails.result.status,
      Date: userDetails.result.dateDisabled,
      ReferenceNumber: userDetails.result.referenceNumber,
      Customer: userDetails.result.name,
      NRIC: userDetails.result.nric,
      "User Name": userDetails.result.username,
      "Mobile No": userDetails.result.mobileNumber,
      "New Mobile No": userDetails.result.tempMobileNumber,
      "Document" :userDetails.result.document,
      Email: userDetails.result.email,
      "Bank Name": userDetails.result.bankName,
      "Account Name": userDetails.result.accName,
      Account: userDetails.result.accNumber,
    },
  };

  // trigger when user click on header when sorting
  const headerFilterClick = (header, sort) => {
    let column = header.column;
    if (sort) {
      if (tableSearchFilter.sortKey === column.searchFilterValue) {
        // if click on the same column previously clicked will enter here
        if (tableSearchFilter.sortDirection === "ASCENDING") {
          // if previously the column is sort by ascending order, sortDir will change to sort by descending order
          setTableSearchFilter({
            ...tableSearchFilter,
            // sortBy: column.searchFilterValue,
            // sortDir: "DESCENDING",
            // pageNumber: 1,

            pageNumber: tableSearchFilter.pageNumber,
            //   pageSize: 50,
            sortDirection: "DESCENDING",
            sortKey: column.searchFilterValue,
          });
        } else {
          // if previously the column is sort by descending order, sortDir will change to sort by ascending order
          setTableSearchFilter({
            ...tableSearchFilter,
            // sortBy: column.searchFilterValue,
            // sortDir: "ASCENDING",
            // pageNumber: 1,
            pageNumber: tableSearchFilter.pageNumber,
            //  pageSize: 50,
            sortDirection: "ASCENDING",
            sortKey: column.searchFilterValue,
          });
        }
      } else {
        // if click on a new column, it will sort by ascending order with the column value (column.searchFilterValue)
        setTableSearchFilter({
          ...tableSearchFilter,
          // sortBy: column.searchFilterValue,
          // sortDir: "ASCENDING",
          // pageNumber: 1,

          pageNumber: tableSearchFilter.pageNumber,
          //pageSize: 50,
          sortDirection: "ASCENDING",
          sortKey: column.searchFilterValue,
        });
      }
    }
  };

  const headerArrowRotate = (active, sort) => {
    // current column header arrow icon will rotate depending on ascending order or descending order (tableSearchFilter.sortDir)
    if (sort) {
      const classNames = ["react-table__icon-wrapper"];
      if (active && tableSearchFilter.sortDir === "DESCENDING")
        classNames.push("react-table__icon-wrapper-down");
      if (active) classNames.push("react-table__icon-wrapper--show");
      return classNames.join(" ");
    }
  };

  const nextPage = async (type) => {
    if (type === "customerDetails") {
      if (
        appList.currentPageNumber < appList.totalPageNumber &&
        !paginationLocker
      ) {
        setTableSearchFilter({
          pageNumber: tableSearchFilter.pageNumber + 1,
          pageSize: tableSearchFilter.pageSize,
          sortDirection: tableSearchFilter.sortDir,
          sortKey: tableSearchFilter.sortKey,
        });
        setPaginationLocker(true);
      } else if (appList.currentPageNumber === appList.totalPageNumber) {
        setPaginationLocker(false);
      }
    } else {
      if (
        userContractDetails.currentPageNumber < appList.totalPageNumber &&
        !paginationLocker
      ) {
        setTableSearchFilter({
          pageNumber: tableSearchFilter.pageNumber + 1,
          pageSize: tableSearchFilter.pageSize,
          sortDirection: tableSearchFilter.sortDir,
          sortKey: tableSearchFilter.sortKey,
        });
        setPaginationLocker(true);
      } else if (appList.currentPageNumber === appList.totalPageNumber) {
        setPaginationLocker(false);
      }
    }
  };

  const previousPage = async (type) => {
    if (type === "customerDetails") {
      if (appList.currentPageNumber > 1 && !paginationLocker) {
        setTableSearchFilter({
          pageNumber: tableSearchFilter.pageNumber - 1,
          pageSize: tableSearchFilter.pageSize,
          sortDirection: tableSearchFilter.sortDir,
          sortKey: tableSearchFilter.sortKey,
        });
        setPaginationLocker(true);
      } else if (appList.currentPageNumber === 1) {
        setPaginationLocker(false);
      }
    } else {
      if (
        userContractDetails.currentPageNumber < appList.totalPageNumber &&
        !paginationLocker
      ) {
        setTableSearchFilter({
          pageNumber: tableSearchFilter.pageNumber + 1,
          pageSize: tableSearchFilter.pageSize,
          sortDirection: tableSearchFilter.sortDir,
          sortKey: tableSearchFilter.sortKey,
        });
        setPaginationLocker(true);
      } else if (userContractDetails.currentPageNumber === 1) {
        setPaginationLocker(false);
      }
    }
  }

  // tableCoumn is to create table column
  const tableColumn = (value) => {
    const table = [];
    let header1_name = value.header1_name;
    let header2_name = value.header2_name;
    let header3_name = value.header3_name;
    let header4_name = value.header4_name;

    if (value.header4 !== undefined) {
      header1_name = "Contract ID";
      header2_name = "Contract Date";
      header3_name = "Payment Status";
      header4_name = "Next Payment Date";
    }
    if (value.header1 !== undefined) {
      table.push({
        id: value.header1,
        // header is the table header for id column
        Header: (header) => {
          return (
            <div
              onClick={() => headerFilterClick(header, value.sort)}
              className="react-table__header"
            >
              <span className="react-table__header-title">{header1_name}</span>
              <div
                className={headerArrowRotate(
                  tableSearchFilter.sortKey === header.column.searchFilterValue,
                  value.sort
                )}
              >
                {value.sort ? <span className="react-table__icon"></span> : ""}
              </div>
            </div>
          );
        },
        // accessor will list out the table data based on the data key. In this case, the mockData key of id
        accessor: value.header1,
        // searchFilterValue is the column value that will send to BE to inform BE to sort according to which column. it is use to update tableSearchFilter.searchValue
        searchFilterValue: value.header1,
        // minWidth, width, maxWidth is to adjust the width of this current column
        minWidth: 200,
        width: 200,
      });
    }
    if (value.header2 !== undefined) {
      table.push({
        id: value.header2,
        Header: (header) => {
          return (
            <div
              onClick={() => headerFilterClick(header, value.sort)}
              className="react-table__header"
            >
              <span className="react-table__header-title">{header2_name}</span>
              <div
                className={headerArrowRotate(
                  tableSearchFilter.sortKey === header.column.searchFilterValue,
                  value.sort
                )}
              >
                {value.sort ? <span className="react-table__icon"></span> : ""}
              </div>
            </div>
          );
        },
        searchFilterValue: value.header2,
        accessor: value.header2,
        minWidth: 160,
        width: 160,
      });
    }

    if (value.header3 !== undefined) {
      table.push({
        id: value.header3,
        Header: (header) => {
          return (
            <div
              onClick={() => headerFilterClick(header, value.sort)}
              className="react-table__header"
            >
              <span className="react-table__header-title">{header3_name}</span>
              <div
                className={headerArrowRotate(
                  tableSearchFilter.sortKey === header.column.searchFilterValue,
                  value.sort
                )}
              >
                {value.sort ? <span className="react-table__icon"></span> : ""}
              </div>
            </div>
          );
        },
        searchFilterValue: value.header3,
        accessor: value.header3,
        minWidth: 180,
        width: 180,
      });
    }

    if (value.header4 !== undefined) {
      table.push({
        id: value.header4,
        Header: (header) => {
          return (
            <div
              onClick={() => headerFilterClick(header, value.sort)}
              className="react-table__header"
            >
              <span className="react-table__header-title">{header4_name}</span>
              <div
                className={headerArrowRotate(
                  tableSearchFilter.sortKey === header.column.searchFilterValue,
                  value.sort
                )}
              >
                {value.sort ? <span className="react-table__icon"></span> : ""}
              </div>
            </div>
          );
        },

        searchFilterValue: value.header4,
        accessor: value.header4,
        minWidth: 180,
        width: 180,
      });
    }

    table.push({
      id: "button",
      Header: "",
      Cell: (row) => {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => viewPage(row.row.original, value.table_title)}
              className="react-table__search-button"
            >
              <FiSearch size={24} />
            </button>
          </div>
        );
      },
      minWidth: 70,
      width: 70,
    });

    return table;
  };

  const history = useHistory();
  const viewPage = async (value, view_type) => {
    if (view_type === "application") {
      history.push(
        pathnames.pageLoanApplicationView.replace(
          ":staffId",
          value.id.toString()
        )
      );
    } else {
      history.push(
        pathnames.pageLoanContractView.replace(
          ":contractId",
          value.id.toString()
        )
      );
    }
  };
  const { customerId } = useParams();
  //const dispatch = useDispatch();
  const [appList, setAppList] = useState(undefined);
  const [viewData, setViewData] = useState({});

  //Audit Trail
  const getTableRowClassNames = (index) => {
    const classNames = ["audit-trail-modal__table-row"];
    if (index % 2 === 0) classNames.push("audit-trail-modal__table-row--gray");
  
    return classNames.join(" ");
  };
  const [auditTrailModal, setAuditTrailModal] = useState({
    isOpen: false,
  });
  const auditTrail = () => {
    setAuditTrailModal({ isOpen: true });
  };

  const AuditTrailModal = ({ isOpen, toggle, dataList }) => {
    return (
      <Modal className="audit-trail-modal" contentClassName="audit-trail-modal__content" isOpen={isOpen}>
        <div className="audit-trail-modal__body">
          <div className="audit-trail-modal__header-row">
            <div className="audit-trail-modal__column-timestamp">
              <span>Timestamp</span>
            </div>
            <div className="audit-trail-modal__column-details">Details</div>
            <div className="audit-trail-modal__column-by">By</div>
          </div>
          <div className="audit-trail-modal__table-body"> 
          {dataList && dataList.length
            ? dataList.map((o, i) => (
                  <div key={i} className={getTableRowClassNames(i)}>
                    <div className="audit-trail-modal__column-timestamp">
                      <span>{o.timestamp}</span>
                    </div>
                    <div className="audit-trail-modal__column-details">{o.message}</div>
                    <div className="audit-trail-modal__column-by">{o.updatedBy}</div>
                  </div>
                ))
              : null}
              {dataList.length === 0 && 
                 <div className="audit-trail-modal"
                 style={{textAlign:"end", fontWeight:"bold", fontSize:"20px"}}>
                  No data is found !</div>
                  }
          </div>
        </div>
        <div className="audit-trail-modal__button-wrapper">
          <AppButton colorType="orange" label="Back" onClick={toggle} />
        </div>
      </Modal>
    );
  };

  const [userContractDetails, setUserContractDetails] = useState(undefined);
  const [tabCol1, setTabCol1] = useState("tab-selected");
  const [tabCol2, setTabCol2] = useState("tab2");
  const [firstTab, setFirstTab] = useState("display");
  const [secondTab, setSecondTab] = useState("hide");
  const [contentStyling, setContentStyling] = useState("merchant-detail");
  const [paginationLocker, setPaginationLocker] = useState(true);
  const [customerContractAccess, setCustomerContractAccess] = useState({
    view_contract_list: false,
  });
  const [customerDetailAccess, setCustomerDetailAccess] = useState({
    update_mobile_number: false,
    approve_reject_mobile_number:false,
    audit_trail: false
  });
  useEffect(() => {
    const appId = customerId;
    let token = null;
    token = localStorage.getItem("@storage_token");

    let roles = localStorage.getItem("decode_token");
    if (roles == CONSTANSTS.ROLES.finance) {
      console.log("Access Denied");
      history.push(pathnames.pageCustomerList);
    }

    let customerAccess = null;
      customerAccess = JSON.parse(localStorage.getItem("accessMatrix"));
      if(customerAccess) {
        setCustomerContractAccess(customerAccess.accessMatrix.Customer_Contract);
        setCustomerDetailAccess(customerAccess.accessMatrix.Customer_Detail);
      }

    fetch(
      // "http://49.0.203.50/ivc-app/bo/customer/api/v1/applicationList?customerID=" +
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.GET_CUSTOMER_APPLICATION_LIST +
        "?customerId=" +
        appId +
        "&pageNumber=" +
        tableSearchFilter.pageNumber,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
          // customerID: appId,
          // pageNumber: tableSearchFilter.pageNumber,
          Authorization: "Bearer " + token,
        },
      }
    )
      .then((response) => response.json())
      .then((json) => {
        let result = json.result;
        setPaginationLocker(false);
        setAppList(result);
      });

    fetch(
      // "http://49.0.203.50/ivc-app/bo/customer/api/v1/get/" + appId,
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.GET_CUSTOMER_BYID +
        appId,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
          // customerID: appId,
          // pageNumber: tableSearchFilter.pageNumber,
          Authorization: "Bearer " + token,
        },
      }
    )
      .then((response) => response.json())
      .then((json) => {
        let result = json.result;

        setUserDetails({ result });
        setViewData(result);
        setMobile(result.mobileNumber);
      });

    fetch(
      // "http://49.0.203.50/ivc-app/bo/customer/api/v1/contractList?customerID=" +
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.GET_CUSTOMER_CONTRACT_LIST +
        "?customerId=" +
        appId,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
          // customerID: appId,
          // pageNumber: tableSearchFilter.pageNumber,
          Authorization: "Bearer " + token,
        },

        body: JSON.stringify(tableSearchFilter),
      }
    )
      .then((response) => response.json())
      .then((json) => {
        let result = json.result;
        setUserContractDetails(result);
      });
  }, [tableSearchFilter]);

  //   const [cdTab, setCDTab] = useState("contents");
  const tabClicked = (e) => {
    let roles = localStorage.getItem("decode_token");
    // if (roles == CONSTANSTS.ROLES.finance && roles == CONSTANSTS.ROLES.creditOfficer) {
    //   console.log("Access Denied");
    //   history.push(pathnames.pageCustomerList);
    // }

    var tabNo = e;
    if (tabNo === "1") {
      setTabCol1("tab-selected");
      setTabCol2("tab2");
      setFirstTab("display");
      setSecondTab("hide");

      setContentStyling("merchant-detail");
      //  /  applicationData()
      //   setCDTab("contents");
    }
    if (tabNo === "2" && roles !== CONSTANSTS.ROLES.creditOfficer && roles !== CONSTANSTS.ROLES.finance) {
      setTabCol1("tab1");
      setTabCol2("tab-selected");
      setFirstTab("hide");
      setSecondTab("display");

      setContentStyling("merchant-detail-2");
    }
  };

  const [mobile, setMobile] = useState();
  const [disabled, setDisabled] = useState(true);
  //console.log(mobile);
  const appId = customerId;

  const updateMobileNo = () => {
    let mobileNo = mobile;
    let token = null;
    token = localStorage.getItem("@storage_token");
    try {
      fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.UPDATE_CUSTOMER_MOBILE_NO, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          id:appId,
          mobileNumber: mobileNo,
        }),
      })
        .then((response) => response.json())
        .then((json) => {
          if (json.responseCode === 200) {
            messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.success, title: CONSTANSTS.DIALOG_TITLE.general_success, message: json.message });

            // appToast("Remark successfully update", true);
          } else {
            messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: json.message, defaultOnClick: false });
            // appToast(json.message, false);
          }
        });
      //dispatch(updateUserList(response));
    } catch (error) {
      console.log("error", error);
    }
  };

  const mobileNoApproval = async (action) => {
    //console.log("MobileApproval - param -", value, isApprove);
    let tempStatus = '';
    let token = null;
    if (action) {
      tempStatus = "APPROVED"
    } else {
      tempStatus = "REJECTED"
    }
    token = localStorage.getItem("@storage_token");
    fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.UPDATE_APPROVAL_MOBILE_NO , {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id:appId,
        status: tempStatus,
      }),
    })
    .then((response) => response.json())
    .then((json) => {
      if (json.responseCode === 200) {
        messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.success, title: CONSTANSTS.DIALOG_TITLE.general_success, message: json.message });

        // appToast("Remark successfully update", true);
      } else {
        messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: json.message, defaultOnClick: false });
        // appToast(json.message, false);
      }
    });
  };

  const handleChange = event => {
    setMobile(event.target.value);
    setDisabled(false);
  };

  return (
    <div className="merchant-view">
      <AuditTrailModal dataList={viewData.auditTrails ? viewData.auditTrails : []} isOpen={auditTrailModal.isOpen} toggle={() => setAuditTrailModal({ isOpen: false })} />
      <div className="top-context">
        <div className="tabs">
          <div>
          <div
            className={"tablinks " + tabCol1}
            onClick={() => tabClicked("1")}
          >
            <span>Customer Details</span>
          </div>
          {customerContractAccess.view_contract_list && (<div
            className={"tablinks " + tabCol2}
            onClick={() => tabClicked("2")}
          >
            <span>Contracts</span>
          </div>)}
        </div>
        <div className="search-button" hidden={customerContractAccess.audit_trail}>
          <AppButton colorType="orange" label="Audit Trail" onClick={auditTrail}></AppButton>
        </div>
      </div>
      </div>
      <div className={contentStyling} style={{ minWidth: "1340px" }}>
        <div className={firstTab}>
          
          <div className="row" style={{ marginTop: "40px" }}>
            
            <div
              className="col-5"
              style={{
                fontFamily: "gotham-bold",
                fontSize: "28px",
                wordBreak: "break-all",
              }}
            >
              {Object.keys(temUserDetails.result).map((key, i) =>
                // <CustomerValue key={i} data={key}></CustomerValue>   
               {if(key == "Mobile No")
                {
                  return <div className="row" key={i} style={{ paddingTop: "30px" }}>
                    <span className="col-5">{key}</span>
                    <span
                      className="col-7"
                      style={{
                        fontFamily: "gotham-light",
                        fontSize: "28px",
                        wordBreak: "break-all",
                      }}
                    >
                      <div className="page-loan-application-list__react-table-wrapper">
                        {/* <input 
                          type="text" 
                          name="mobileNo"
                          maxLength={11} 
                          value={mobile} 
                          onChange={handleChange} 
                          style={{ maxWidth: "250px", outline:"none", borderRadius:"8px", marginRight: '10px' }}
                          readOnly={temUserDetails.result["New Mobile No"] != null || customerDetailAccess.update_mobile_number}
                        />             */}
                        <span
                      className="col-7"
                      style={{
                        fontFamily: "gotham-light",
                        fontSize: "28px",
                        wordBreak: "break-all",
                      }}
                    >
                      {temUserDetails.result[key]}
                    </span>
                        <button  className="react-table__icon-button" hidden={temUserDetails.result["New Mobile No"]!=null || disabled}>
                          <IoSaveOutline size={24} onClick={updateMobileNo} style={{ marginBottom: "10px" }}/>
                        </button>
                      </div>
                    </span>
                  </div>
                }
                else if(key == "New Mobile No") {
                  if (temUserDetails.result["New Mobile No"]) {
                    return <div className="row" key={i} style={{ paddingBottom: "30px" }}>
                    <span className="col-5">{key}</span>
                    <span
                      className="col-7"
                      style={{
                        fontFamily: "gotham-light",
                        fontSize: "28px",
                        wordBreak: "break-all",
                      }}
                    >
                      <div className="page-loan-application-list__react-table-wrapper">
                        <input 
                          type="text" 
                          disabled 
                          name="mobileNo" 
                          maxLength={11} 
                          value={temUserDetails.result["New Mobile No"]} 
                          onChange={handleChange} 
                          style={{ maxWidth: "250px", outline:"none", borderRadius:"8px", marginRight:'10px' }} 
                        />
                        {customerDetailAccess.approve_reject_mobile_number && (
                          <>
                            <button className="react-table__icon-button" style={{ marginRight: "10px" }}>
                              <IoCheckmark size={25} onClick={() => mobileNoApproval(true)} style={{ marginBottom: "10px" }} />
                            </button>
                            <button className="react-table__icon-button">
                              <IoClose size={24} onClick={() => mobileNoApproval(false)} style={{ marginBottom: "10px" }} />
                            </button>
                          </>
                        )}
                      </div>
                    </span>
                  </div>
                  }
                }
                else if(key == "Document") {
                  if (temUserDetails.result["Document"]) {
                    return <div className="row" key={i} style={{ paddingBottom: "30px" }}>
                    <span className="col-5">{key}</span>
                    <span
                      className="col-7"
                      style={{
                        fontFamily: "gotham-light",
                        fontSize: "28px",
                        wordBreak: "break-all",
                      }}
                    >
                      <div className="page-loan-application-list__react-table-wrapper">
                      <a href={temUserDetails.result.Document} target="_blank" rel="noreferrer" style={{textDecoration:"none"}} className="loan-application-view__score-ctos-report">
                      View Document
                      </a>
                      </div>
                    </span>
                  </div>
                  }
                }
                 else {
                  return <div className="row" key={i} >
                    <span className="col-5">{key}</span>
                    <span
                      className="col-7"
                      style={{
                        fontFamily: "gotham-light",
                        fontSize: "28px",
                        wordBreak: "break-all",
                      }}
                    >
                      {temUserDetails.result[key]}
                    </span>
                  </div>
                }}
              )}
              
            </div>

            <div
              className="col-7"
              style={{ backgroundColor: "white", borderRadius: "8px" }}
            >
              <div
                className="pagination-button w-100 "
                style={{ borderBottom: "2px solid black" }}
              >
                <span className="row">
                  <span
                    className="col-10"
                    style={{
                      fontFamily: "gotham-bold",
                      fontSize: "30px",
                      color: "#A28559",
                    }}
                  >
                    Application Status
                  </span>
                  {appList !== undefined ? (
                    <span className="col  m-auto">
                      {tableSearchFilter.pageNumber === 1&&
                    appList.totalCount > 0
                      ? tableSearchFilter.pageNumber
                      : tableSearchFilter.pageNumber === 1 &&
                      appList.totalCount === 0
                      ? appList.totalCount
                        : 1 +
                          appList.pageSize *
                            (appList.currentPageNumber - 1)}{" "}
                      -{" "}
                      { appList.pageSize * (appList.currentPageNumber - 1) +
                          appList.currentCount}{" "}
                      of {appList.totalCount}{" "}
                      <button onClick={() => previousPage("customerDetails")}>
                        ❮
                      </button>
                      <button onClick={() => nextPage("customerDetails")}>
                        ❯
                      </button>
                    </span>
                  ) : (
                    <></>
                  )}
                </span>
              </div>
              <div
                className="page-loan-application-list__react-table-wrapper"
                style={{ marginTop: "10px" }}
              >
                {appList !== undefined && appList.data !== undefined ? (
                  <AppReactTable
                    columns={tableColumn({
                      header1: "referenceNumber",
                      header2: "dateRequested",
                      header3: "status",
                      table_title: "application",
                      sort: false,
                      header1_name: "Application ID",
                      header2_name: "Request Date",
                      header3_name: "Status",
                    })}
                    data={appList.data}
                    headerClass="customerDetailsHeader"
                    headerRowClass="customerDetailsHeader__row"
                    rowHeaderClass="customerDetailsHeader__row-header"
                    bodyClass="customerDetailsBody"
                    bodyRowClass="customerDetailsBody__row"
                    bodyDataClass="customerDetailsBody__row-data"
                  />
                ) : (
                  <div></div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className={secondTab}>
          <div
            className="row"
            style={{
              fontFamily: "gotham-bold",
              fontSize: "30px",
              paddingLeft: "30px",
            }}
          >
            <div className="col-1 me-5">
              <div>Customer</div>
              <div>NRIC</div>
            </div>
            <div
              className="col-2"
              style={{ fontFamily: "gotham-light", width: "fit-content" }}
            >
              <div
                style={{
                  backgroundColor: "white",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  borderRadius: "5px",
                  border: "1px solid #F6F6F6",
                }}
              >
                {userDetails.result.name}
              </div>
              <div
                style={{
                  backgroundColor: "white",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  borderRadius: "5px",
                  border: "1px solid #F6F6F6",
                }}
              >
                {userDetails.result.nric}
              </div>
            </div>
          </div>

          <div className="col">
            <div className="pagination-button w-100">
              <span className="row">
                {userContractDetails !== undefined ? (
                  <span className="col me-5 text-end">
                    {tableSearchFilter.pageNumber === 1 &&
                    userContractDetails.totalCount > 0
                      ? tableSearchFilter.pageNumber
                      : tableSearchFilter.pageNumber === 1 &&
                        userContractDetails.totalCount === 0
                      ? userContractDetails.totalCount
                      : 1 +
                        userContractDetails.pageSize *
                          (userContractDetails.currentPageNumber - 1)}{" "}
                    -{" "}
                    {userContractDetails.pageSize *
                          (userContractDetails.currentPageNumber - 1) +
                        userContractDetails.currentCount}{" "}
                    of {userContractDetails.totalCount}{" "}
                    <button onClick={() => previousPage("contractDetails")}>
                      ❮
                    </button>
                    <button onClick={() => nextPage("contractDetails")}>
                      ❯
                    </button>
                  </span>
                ) : (
                  <></>
                )}
              </span>
            </div>
            <div
              className="page-loan-application-list__react-table-wrapper"
              style={{ marginTop: "10px" }}
            >
              {userContractDetails !== undefined &&
              userContractDetails.data !== undefined ? (
                <AppReactTable
                  columns={tableColumn({
                    header1: "referenceNumber",
                    header2: "contractDate",
                    header3: "paymentStatus",
                    header4: "dateNextPayment",
                    table_title: "contract",
                    sort: true,
                  })}
                  data={userContractDetails.data}
                  headerClass="userContractDetailsHeader"
                  headerRowClass="userContractDetailsHeader__row"
                  rowHeaderClass="userContractDetailsHeader__row-header"
                  bodyClass="userContractDetailsBody"
                  bodyRowClass="userContractDetailsBody__row"
                  bodyDataClass="userContractDetailsBody__row-data"
                />
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageCustomerView;
